import * as React from 'react';
import { useState } from 'react';
import styled from '@emotion/styled';
import { InputContainerWidget } from '../../../widgets/forms/InputContainerWidget';
import { ImageUploadInputWidget } from '../../../widgets/forms/ImageUploadInputWidget';
import { MediaUpload } from '../../../core/media/MediaUpload';
import { Crop } from '@foxbun/lib-goferal-types';
import { ButtonType, ButtonWidget } from '../../../widgets/controls/ButtonWidget';

export interface SimpleImageFormOptions {
  label: string;
  handle: (event: { upload: MediaUpload; file: File; crop: Crop }) => Promise<any>;
  aspect_ratio?: number;
}

export const SimpleImageForm: React.FC<SimpleImageFormOptions> = (props) => {
  const [file, setFile] = useState<File>();
  const [crop, setCrop] = useState<Crop>();
  const [uploading, setUploading] = useState(false);
  return (
    <S.Container>
      <InputContainerWidget label={props.label}>
        <ImageUploadInputWidget
          aspect_ratio={props.aspect_ratio}
          file={file}
          changed={async (file, crop) => {
            setFile(file);
            setCrop(crop);
          }}
        ></ImageUploadInputWidget>
      </InputContainerWidget>
      {crop && file ? (
        <ButtonWidget
          label="Clear"
          type={ButtonType.SECONDARY}
          action={async () => {
            setFile(null);
            setCrop(null);
          }}
        />
      ) : null}
      <ButtonWidget
        label="Save"
        loading={uploading}
        disabled={!crop || !file}
        action={async () => {
          setUploading(true);
          let upload = new MediaUpload(file);
          await props.handle({
            upload,
            crop,
            file
          });
          setUploading(false);
        }}
      />
    </S.Container>
  );
};
namespace S {
  export const Container = styled.div`
    display: flex;
    align-items: stretch;
    flex-direction: column;
    row-gap: 10px;
  `;
}
